import { Link } from 'gatsby'
import isLocal from './isLocal'

export default ({
  element,
}) => (
  isLocal({ element }) ? Link : 'a'
)
